import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const rejectRegisterRequest = async (id: string) => {
  return await axiosInstance
    .delete(`user/signUp/reject/${id}`)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useRejectRegister = () => {
  return useMutation({
    mutationFn: (id: string) => rejectRegisterRequest(id),
    mutationKey: ["notification"],
  });
};
export default useRejectRegister;
